<template>
  <div class="flex flex-col gap-16 pt-16">
    <p v-if="checkoutStore.ui.customerRequiresAuth">
      Identifiera dig med BankID för ett tryggt köp och få den bästa
      leveransmetoden.
    </p>

    <AppBankID
      v-if="checkoutStore.ui.customerRequiresAuth"
      @on-complete="onIdentified($event)"
    />

    <LazyAppTestBankIDReplacement
      v-if="isTestEnvironment() && checkoutStore.ui.customerRequiresAuth"
      :is-loading-passthrough="
        checkoutStore.ui.bankIdTestPassthroughIsSubmitting
      "
      @on-complete="onIdentified($event)"
    />
  </div>
</template>

<script lang="ts" setup>
import type { BankIdOnIdentifiedEvent } from '~/models/bankid/bankIdOnIdentifiedEvent.model';
import { isTestEnvironment } from '~/utils/general/isTestEnvironment';

const checkoutStore = useMyCheckoutStore();
const notificationStore = useNotificationStore();

const emit = defineEmits(['onAuth']);

const onIdentified = async (eventData: BankIdOnIdentifiedEvent) => {
  const { bankIdCollectResponse, isUsingBankIdReplacement, testPersonaSsn } =
    eventData;

  if (
    isUsingBankIdReplacement !== true &&
    bankIdCollectResponse?.StatusDescription !== 'COMPLETE'
  ) {
    return;
  }

  if (
    isUsingBankIdReplacement !== false &&
    bankIdCollectResponse?.StatusDescription === 'COMPLETE' &&
    bankIdCollectResponse?.HasClearedCartBecauseDifferentSsnAuthorized === true
  ) {
    notificationStore.setNewNotification({
      type: 'error',
      title: 'Ett fel uppstod',
      msg: 'Du har identifierat dig som en annan person än tidigare under det här besöket. Tyvärr har vi behövt rensa din varukorg åt dig.',
      isCloseable: true,
      link: {
        url: 'https://www.halebop.se/support',
        text: 'kontakta supporten',
      },
    });

    checkoutStore.clearCartData();
    await checkoutStore.fetchCart();
    return;
  }

  emit('onAuth', { isUsingBankIdReplacement, testPersonaSsn });
};

onMounted(() => {
  checkoutStore.ui.bankIdTestPassthroughIsSubmitting = false;
});
</script>

<style lang="scss" scoped></style>
